<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow alignHorizontal="center" alignVertical="center">
        <CCol col="1">
          <CRow alignHorizontal="end">
            <div class="containerIconLeft" @click="linkBackTo(content)">
              <font-awesome-icon icon="chevron-left" class="IconLeft" />
            </div>
          </CRow>
        </CCol>
        <CCol col="10">
          <CRow>
            <CCol col="12">
              <CardContent :cardContent="content" @nextRoute="nextRoute" />
            </CCol>
          </CRow>
        </CCol>
        <CCol col="1">
          <div class="containerIconRight" @click="linkNextTo(content)">
            <font-awesome-icon
              v-if="!loading"
              icon="chevron-right"
              class="IconRight"
            />
            <font-awesome-icon
              v-if="loading"
              icon="spinner"
              class="IconRight"
            />
          </div>
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import CardContent from '../../../components/template/Chinese1/CardContent';
import CardPopupImg from './components/CardPopupImg.vue';
import {mapGetters} from 'vuex';
import '../../../assets/scss/_chineseStyle.scss';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardContent, CardPopupImg, LoadingMDL},
  name: 'CTA04',
  data() {
    return {
      content: {},
      lang: this.$store.getters['language/getLanguage'],
      pageCode: '',
      baseURL: 'CTA04-',
      isModalVisible: false,
      popupData: {},
      cardType: 'img',
      isChange: false,
      newPath: '',
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      isCompletedLoad: false,
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      // getUserTemplate: 'template/getUserTemplate',
      // loadingGetter: 'template/loadingGetter',
      getCourseChapterAndProgress: 'template/getCourseChapterAndProgress',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }

      // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

      this.loading = false;
    },
    // allCourse: function (val) {
    //   if (!val.enable) {
    //     alert('Access denied!');
    //     var url = this.$helpers.updatePathCHN(val.navigate.close.action);
    //     this.$router.push(url);
    //   } else {
    //     this.content = val;
    //     this.courseSection =
    //       this.$store.getters['necessary/getUserCourseSection'];
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: val._id,
    //       section: this.courseSection,
    //     });
    //   }
    //   this.loading = false;
    // },
    storeLanguage: function (val) {
      this.lang = val;
    },
    // getUserTemplate: function (val) {
    //   this.userTemplateData = val;
    //   this.condition.push({
    //     criteria: val.data.condition.criteriaType[0]._id,
    //     val: val.data.condition.criteriaType[0].val,
    //   });
    //   this.loading = false;
    // },
    // loadingGetter: function (val) {
    //   if (val == true) {
    //     this.isCompletedLoad = !this.isCompletedLoad;
    //   }
    // },
    // isCompletedLoad: function () {
    //   let str = this.nextAction.split('-');
    //   let body = '/' + str[0] + '/' + str[1];
    //   this.$store.commit('necessary/setCodePage', str[1]);
    //   if (this.getParams == 3) {
    //     this.$router.push(body);
    //   } else if (this.getParams > 3 && this.getParams < 7) {
    //     let bodyFetch = {};
    //     bodyFetch.code = this.courseCode;
    //     bodyFetch.templateCode = this.nextAction;
    //     this.$store.dispatch('template/fetchContent', bodyFetch);

    //     this.$router.push(body);
    //   } else if (
    //     this.getParams == 7 ||
    //     this.getParams == 17 ||
    //     this.getParams == 20 ||
    //     this.getParams == 24
    //   ) {
    //     this.$router.push(body);
    //   } else if (str[0] === 'CTA04') {
    //     let bodyFetch = {};
    //     bodyFetch.code = this.courseCode;
    //     bodyFetch.templateCode = this.nextAction;
    //     this.$store.dispatch('template/fetchContent', bodyFetch);
    //     this.$router.push(body);
    //   } else {
    //     this.$router.push(body);
    //   }
    //   this.loading = false;
    // },
    $route(to, form) {
      this.onLoad();
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.getParams = this.$route.params.id;
      this.lang = this.$store.state.language.language;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `CTA04-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    nextRoute(path) {
      if (path.type == undefined) {
        const splitPath = path.path.split('-');
        const nextPath = `/v3/${splitPath[0]}/${splitPath[1]}`;
        this.$router.push(nextPath);
      }
    },
    returnData(str) {
      this.isChange = true;
      this.newPath = str[0] + '-' + str[1];
    },
    linkNextTo(path) {
      // this.loading = true;
      this.nextAction = path.navigate.next.action;
      //data form
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch
      this.$store.dispatch('v3/saveContent', data);

      const next = this.nextAction.split('-');

      const nextPath = `/v3/${next[0]}/${next[1]}`;

      this.$router.push(nextPath);

      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });
    },
    linkBackTo(path) {
      const previousAction = path.navigate.previous.action;

      const previous = previousAction.split('-');
      var pathCheck = previous[0];
      const previousPath = `/v3/${previous[0]}/${previous[1]}`;

      if (pathCheck === 'CTA04') {
        this.loading = true;
        //CTA04

        this.$router.push(previousPath);
      } else {
        this.$router.push(previousPath);
      }
    },
  },
};
</script>
<style></style>
